"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useListToolbarButtonState = exports.useListToolbarButton = void 0;
var _plateCommon = require("@udecode/plate-common");
var _plateList = require("@udecode/plate-list");
var useListToolbarButtonState = function useListToolbarButtonState() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$nodeType = _ref.nodeType,
    nodeType = _ref$nodeType === void 0 ? _plateList.ELEMENT_UL : _ref$nodeType;
  var pressed = (0, _plateCommon.useEditorSelector)(function (editor) {
    return !!editor.selection && (0, _plateCommon.someNode)(editor, {
      match: {
        type: (0, _plateCommon.getPluginType)(editor, nodeType)
      }
    });
  }, [nodeType]);
  return {
    nodeType: nodeType,
    pressed: pressed
  };
};
exports.useListToolbarButtonState = useListToolbarButtonState;
var useListToolbarButton = function useListToolbarButton(state) {
  var editor = (0, _plateCommon.useEditorRef)();
  return {
    props: {
      onClick: function onClick() {
        (0, _plateList.toggleList)(editor, {
          type: state.nodeType
        });
      },
      onMouseDown: function onMouseDown(e) {
        e.preventDefault();
      },
      pressed: state.pressed
    }
  };
};
exports.useListToolbarButton = useListToolbarButton;